<template>
    <b-modal
        id="reject-student-modal"
        v-model="modal"
        ref="reject-student-modal"
        size="md"
        :title="$t('internship.reject_student')"
        modal-class="apprentice-default-modal signout-student-modal"
        :ok-title="$t('internship.reject')"
        cancel-variant="outline-primary"
        :cancel-title="$t('common.cancel')"
        @ok="rejection()">
        <form>
            <b-form-group
                class="internship-rejection-letter"
                label-for="internship-rejection-letter-input"
                :label="$t('internship.motivation')">
                <b-form-input
                    id="internship-rejection-letter"
                    v-model="rejectionLetter"
                    :placeholder="$t('internship.you_have_been_rejected_for_the_next_reason')">
                </b-form-input>
            </b-form-group>
        </form>
    </b-modal>
</template>

<script>
// import {ords} from "../../../app";
// import moment from "moment";

export default {
    name: 'design-2021-internship-edit-applying-students-tab-rejection-modal-component',
    emits: ['signout'],
    props: {
        internshipIn: Object,
    },
    data() {
        return {
            rejectionLetter: '',
            loaded: false,
            modal: false,
            studentId: '',
        };
    },
    methods: {
        show(studentId) {
            if (!this.loaded) {
                this.loaded = true;
                this.modal = true;
                this.studentId = studentId;
            }
        },
        rejection() {
            const data = {
                rejectionLetter: this.rejectionLetter,
            };
            this.axios
                .delete(this.routes.internshipRejectStudent(this.studentId, this.internshipIn.id), { data: data })
                .then(
                    (response) => {
                        this.alert.success();
                        this.$emit('reject', this.studentId);
                    },
                    (error) => {
                        this.alert.ajaxError(error);
                    },
                );
        },
    },
    computed: {},
    mounted() {},
};
</script>

<style scoped lang="scss">
.sidebar {
    margin-bottom: $grid-gutter-width;
}

.internships {
    .internship-item {
        margin-bottom: map-get($grid-gutter-spacing, 'fifteen');

        .internship-card {
            &.closed {
                filter: grayscale(1);
            }
        }
    }
}

.internship-show-actions {
    display: flex;
    flex-direction: row;
    align-items: center;

    > .btn {
        &:not(:last-child) {
            margin-right: map-get($grid-gutter-spacing, 'eight');
        }

        &:before {
            margin-right: 0;
        }
    }
}

.not-found {
    margin-top: #{3 * map-get($grid-gutter-spacing, 'twenty-one')};
}
</style>
